import { get } from "lodash-es";
import { postDrafts } from "../../apis/drafts";
import { getApprobalListByParam } from "../../utils/approval";
import { getYear, dateToFormat } from "../../utils/date";
import store from "../../store";
const getTask = async ({ mode, defaultData }) => {

  const employee = store.getState()?.Profile?.employee;
  const getTitle = () => {
    return `${dateToFormat(getYear(1), 'YYYY')}년 ${employee?.name || 'XXX'} 연말 정산 자료`;
  };
  const fields = [
    {
      title: "제목",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "정보",
      tooltip: `이름 / 주민등록 번호\n 부양가족(없으면 공란) : 이름 / 주민등록번호\n그 외 기타 연말정산 특이사항 입력`,
      tooltipPosition: 'right',
      key: "content",
      type: "textarea",
      required: true,
    },
    {
      title: "종전 근무지",
      tooltip: `종전근무지: 이전해 다른 직장 근무 여부`,
      tooltipPosition: 'right',
      key: "before",
      type: 'select',
      options: {
        list: [
          {
            label: "없음",
            value: "N",
          },
          {
            label: "있음",
            value: "Y",
          },
        ],
      },
      // type: "checkbox",
      // onChange: (checked) => {
      //   setForm({
      //     ...form,
      //     includeDeletedEmployee: checked
      //   })
      // }
    },
    {
      title: "첨부파일",
      tooltip: `간소화 자료 PDF 첨부, 종전근무지 있는 경우 종전근무지 원천징수 영수증 첨부, 그 외 PDF 첨부`,
      tooltipPosition: 'right',
      key: "uploadFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
  ];

  const defaultForm = {
    title: get(defaultData, 'data.draft.title', getTitle()),
    content: get(defaultData, 'data.draft.content', `${employee?.name || 'XXX'} / 주민등록번호\n부양가족(없으면 삭제) : 이름 / 주민등록번호\n그 외 특이사항 : (안경, 거주비 등..)`),
    before: get(defaultData, 'data.draft.extendData', 'N'),
    uploadFiles: get(defaultData, 'data.draft.uploadFiles', []),
  };

  const create = (form) => {

    const params = {
      title: form.title,
      content: form.content,
      type: "year_end_draft",
      extendData: form.before,
      uploadFiles: form.uploadFiles,
      approvals: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
    };

    return postDrafts(params);
  };
  const validate = (form) => {
    let errors = {};
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };
};

export default getTask;